import type { JSONValue } from '@/types/shared/json-schema';
import type { UUID } from '@/utils/uuid';

/** The only permission that reads sensitive content; there is no `sensitive_content:manage`. */
export const SENSITIVE_CONTENT_READ = 'sensitive_content:read';

/** Promote also needs these, beside `sensitive_content:read`. */
export const PROMOTE_PERMISSIONS = [
  'secrets:manage',
  'catalog:manage',
] as const;

/** The API's largest page; it has no cursor, so this is all a list can show. */
export const SENSITIVE_CONTENT_LIST_LIMIT = 1000;

/** Metadata of a value an action returned; the value itself is never part of it. */
export interface SensitiveContent {
  id: string;
  connectorId: UUID;
  /** Empty when the caller cannot read the connector or it no longer resolves. */
  connectorName: string;
  featureId: UUID;
  /** Empty when the caller cannot read the feature or it no longer resolves. */
  featureName: string;
  runSequence: number;
  collectedAt: string;
  expiresAt: string;
  /** Empty when the value is stored free-form. */
  templateName: string;
  /** The value did not match the template the connector named, so it is stored free-form. */
  templateMismatch: boolean;
  sizeBytes: number;
}

export interface SensitiveContentList {
  items: SensitiveContent[];
  /** More live rows exist than the list returned. */
  truncated: boolean;
}

/** A revealed value: the JSON the action returned. */
export interface SensitiveContentValue {
  value: JSONValue;
}
